/**
 * @file Range validator for numbers
 * @author Maarten Lensink
 */
import { Validator } from 'breeze-client';
var NAME_RANGE_VALIDATOR = 'range';
/**
 * This validator validates that the number value is between MIN and MAX
 */
export function RangeValidator(min, max) {
    var validator = new Validator(NAME_RANGE_VALIDATOR, valFunction, { min: min, max: max });
    return validator;
    function valFunction(value, context) {
        var result = value >= context.min && value <= context.max;
        return result;
    }
}
Validator.messageTemplates[NAME_RANGE_VALIDATOR] = 'APP.DOMAIN.VALIDATORS.RANGE';
